import { Zone } from "./../_models/zone";
import { ZoneService } from "./../_services/zone.service";
import { CourierService } from "./../_services/courier.service";
import { Courier } from "./../_models/courier";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-zone-page",
  templateUrl: "./add-zone-page.component.html",
  styleUrls: ["./add-zone-page.component.scss"],
})
export class AddZonePageComponent implements OnInit {
  public isModified = false;
  public zone: Zone;
  public showAddContents = true;
  public couriers: Courier[];

  constructor(
    private location: Location,
    public snackBar: MatSnackBar,
    public zoneService: ZoneService,
    public courierService: CourierService,
    private router: Router
  ) {}

  public back(): void {
    this.location.back();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public ngOnInit(): void {
    this.courierService.getCouriers().subscribe(
      (couriers) => {
        this.couriers = couriers;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve countries");
      }
    );
    this.zone = new Zone();
    this.zone.courierId = 0;
  }

  isZoneValid() {
    return this.zone.name && this.zone.code;
  }

  public save(): void {
    if (!this.isZoneValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.zoneService.addZone(this.zone).subscribe(
      (zone) => {
        this.showSuccessMessage("Zone was added successfully!");
        this.router.navigate(["regional", "zones"]);
      },
      (err) => {
        console.error(err);
        if (err.status == 400) {
          this.showErrorMessage("Invalid values");
        } else {
          this.showErrorMessage(
            "Sorry, your request cannot be process at the moment!"
          );
        }
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public showSuccessMessage(message): void {
    this.snackBar.open(message, "Success", {
      duration: 2000,
    });
  }
}
